import { PromiseHelper } from '../../helpers/PromiseHelper';
import { FullscreenHelper } from '../../helpers/FullscreenHelper';
import { LAYOUT } from '../../constants/Constants';
import { ViewerPlaybackStartEvent, ViewerPlaybackEndEvent, ViewerPlaybackPauseEvent } from '../../types/ViewerEvents.type';
import { AssetViewerViewMapper } from '../../helpers/AssetViewerViewMapper';
export class AudioPresentationRenderer {
    constructor(assetViewerView, presentation) {
        this.assetViewerView = assetViewerView;
        this.presentation = presentation;
        this.container = null;
        this.audio = null;
        this.isActive = false;
        this.isLoading = false;
        this.loadPromise = null;
    }
    get url() {
        const pageIndex = (this.presentation.details && this.presentation.details.firstPageIndex) || 0;
        return this.presentation.urls[pageIndex];
    }
    get dimensions() {
        return { width: 400, height: 200 };
    }
    get hasMetaData() {
        return !!this.dimensions;
    }
    load() {
        this.isLoading = true;
        const defer = PromiseHelper.defer();
        this.loadPromise = defer.promise;
        this.audio = document.createElement('audio');
        this.audio.onloadedmetadata = onLoadedMetaData.bind(this);
        this.audio.onerror = onError.bind(this);
        this.audio.oncanplay = onCanPlay.bind(this);
        this.audio.onplay = onPlay.bind(this);
        this.audio.onended = onEnded.bind(this);
        this.audio.onpause = onPause.bind(this);
        this.addEventListeners();
        this.audio.src = `${this.url}`;
        this.audio.controls = true;
        this.audio.setAttribute('controlsList', 'nodownload');
        this.audio.title = this.assetViewerView.assetViewerItem.displayName;
        this.audio.style.maxWidth = '100%';
        if (this.assetViewerView.assetViewerItem.isDownloadable === false) {
            this.audio.addEventListener('contextmenu', e => e.preventDefault());
        }
        defer.resolve(this.dimensions);
        return defer.promise;
        function onLoadedMetaData() {
            this.isLoading = false;
        }
        function onError(error) {
            this.isLoading = false;
            this.audio.onerror = null;
            this.audio.oncanplay = null;
            this.audio = null;
            defer.reject(error);
            if (this.isActive === true) {
                this.assetViewerView.eventBus.dispatch(new ViewerPlaybackEndEvent({
                    assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(this.assetViewerView)
                }));
                this.isActive = false;
            }
        }
        function onPlay() {
            this.isActive = true;
            this.assetViewerView.eventBus.dispatch(new ViewerPlaybackStartEvent({
                assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(this.assetViewerView)
            }));
        }
        function onCanPlay() {
            if (this.audio) {
                if (this.assetViewerView.viewerLayout.currentView === this.assetViewerView &&
                    this.assetViewerView.config.VIEWER_LAYOUT === LAYOUT.HORIZONTAL) {
                    // IE11 does not support .catch
                    this.audio.play().then(() => { }, console.warn);
                }
                this.audio.onerror = null;
                this.audio.oncanplay = null;
            }
        }
        function onEnded() {
            this.isActive = false;
            this.assetViewerView.eventBus.dispatch(new ViewerPlaybackEndEvent({
                assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(this.assetViewerView)
            }));
        }
        function onPause() {
            this.assetViewerView.eventBus.dispatch(new ViewerPlaybackPauseEvent({
                assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(this.assetViewerView)
            }));
        }
    }
    render(container) {
        this.container = container;
        // TODO compare this with the video renderer, check if the loadPromise is necessary
        const loadPromise = this.loadPromise || this.load();
        return loadPromise.then(() => container.appendChild(this.audio));
    }
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
        if (this.audio) {
            this.audio.pause();
            this.audio.onerror = null;
            this.audio.onplay = null;
            this.audio.onended = null;
            this.audio.onpause = null;
            this.audio = null;
        }
        this.loadPromise = null;
    }
    destroyFinal() {
        this.destroy();
    }
    addEventListeners() {
        this.audio.addEventListener('webkitbeginfullscreen', this.onWebkitBeginFullscreen.bind(this));
        this.audio.addEventListener('webkitendfullscreen', this.onWebkitEndFullscreen.bind(this));
        this.audio.addEventListener('webkitfullscreenchange', this.onWebkitFullscreenChange.bind(this));
    }
    onWebkitBeginFullscreen(event) {
        FullscreenHelper.setWebkitBeginFullscreen(this.audio);
        document.body.classList.add('webkit-full-screen');
    }
    onWebkitEndFullscreen(event) {
        FullscreenHelper.setWebkitEndFullscreen();
        document.body.classList.remove('webkit-full-screen');
    }
    onWebkitFullscreenChange(event) {
        FullscreenHelper.triggerFullscreenChange();
    }
}
//# sourceMappingURL=AudioPresentationRenderer.js.map